<template>
  <b-col lg="4" md="6" class="mb-5">
    <div class="card">
      <b-img :src="data.src" fluid></b-img>
      <div class="card-body">
        <dl>
          <dt><span class="badge badge-info">Exhibition</span></dt>
          <dd>{{ data.exhibition }}</dd>
          <dt><span class="badge badge-info">Date</span></dt>
          <dd>{{ data.date }}</dd>
          <dt><span class="badge badge-info">Location</span></dt>
          <dd>{{ data.location }}</dd>
          <dt><span class="badge badge-info">Booth No.</span></dt>
          <dd>{{ data.boothNo }}</dd>
        </dl>
        <a
          :href="data.more"
          target="_blank"
          class="btn btn-outline-primary btn-block"
          >More Info</a
        >
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ["data"],
};
</script>
<style lang="scss" scoped>
.card {
  img {
    margin: 8px;
  }
}
</style>